import api from '@/api/callingList';
import {EventBus} from "@/eventBus";

export default {
    state: {
        callingList: null,
        ordersInDelivery: null,
        ordersNoBuyout: null,
        ordersRejected: null,
    },
    mutations: {
        SET_CALLING_LIST_ORDERS_IN_DELIVERY(state, payload) {
            state.ordersInDelivery = payload;
        },
        SET_CALLING_LIST_ORDERS_NO_BUYOUT(state, payload) {
            state.ordersNoBuyout = payload;
        },
        SET_CALLING_LIST_ORDERS_REJECTED(state, payload) {
            state.ordersRejected = payload;
        },
    },
    actions: {
        fetchCallingList({ commit, dispatch }) {
            dispatch('setIsLoadingData', true);
            api.getCallingList()
                .then(({data: { data: { delivery, rejects, no_buyout }}}) => {
                    commit('SET_CALLING_LIST_ORDERS_IN_DELIVERY', delivery);
                    commit('SET_CALLING_LIST_ORDERS_NO_BUYOUT', no_buyout);
                    commit('SET_CALLING_LIST_ORDERS_REJECTED', rejects);
                }).finally(() => {
                    dispatch('setIsLoadingData', false);
                });
        },
        postOperatorOrderNote({commit, dispatch}, payload) {
            dispatch("setIsLoadingData", true);
            api.saveOperatorOrderNote(payload)
                .then(({ data: { data: { result }}}) => {
                    if (result.success) {
                        document.getElementById('note-' + payload.orderId).textContent = payload.note;
                    } else {
                        EventBus.$emit('show-calling-list-save-note-error', result)
                    }
                }).finally(() => {
                    dispatch("setIsLoadingData", false);
                });
        },
    },
};